import React from 'react';
import t from 'prop-types';

import styles from './Loader.scss';

/**
 * @param {?number} size - width and height of the radial router
 * @param {?number} stroke - stroke width of the spinning line
 * @param {?boolean} colored - render main color loader instead of white
 * @param {?boolean} centered
 * @returns {JSX.Element}
 */
const Loader = ({ size = 25, stroke = 3, colored, centered }) => (
  <div
    className={`${styles.loader} ${styles[`loaderStroke${stroke}`]} ${colored && styles.colored} ${centered && styles.centered}`}
    style={{ width: `${size}px`, height: `${size}px` }}
  >
    <div style={{ width: `${size}px`, height: `${size}px` }} />
    <div style={{ width: `${size}px`, height: `${size}px` }} />
    <div style={{ width: `${size}px`, height: `${size}px` }} />
    <div style={{ width: `${size}px`, height: `${size}px` }} />
  </div>
);

Loader.propTypes = {
  size: t.number,
  stroke: t.number,
  colored: t.bool,
  centered: t.bool
};

export default Loader;
